import React from "react";
import { ExternalLink } from "lucide-react";

/**
 * Componente de tabela para exibir a lista de distribuições
 */
const DistribuicoesTable = ({
  distribuicoes,
}) => {

  // Função para formatar a data no formato dd/mm/yyyy
  const formatarData = (dataString) => {
    if (!dataString) return "-";
    
    const data = new Date(dataString);
    return data.toLocaleDateString('pt-BR');
  };

  // Função para renderizar ícones de status para anexos e movimentações
  const renderizarStatusBooleano = (valor) => {
    return valor ?
      <span className="text-emerald-600 font-bold">✓</span> :
      <span className="text-slate-300">–</span>;
  };

  // Função para estilizar o status da distribuição
  const renderizarStatus = (status) => {
    if (!status) return "-";
    const cls =
      status === "Pendente" ? "bg-amber-100 text-amber-700" :
      status === "Finalizado" ? "bg-emerald-100 text-emerald-700" :
      "bg-slate-100 text-slate-600";
    return <span className={`inline-flex items-center px-2 py-0.5 rounded text-xs font-medium ${cls}`}>{status}</span>;
  };

  const thCls = "px-4 py-3 text-left text-xs font-semibold text-muted-foreground uppercase tracking-wider";
  const tdCls = "px-4 py-3 text-sm text-foreground";

  return (
    <div className="bg-white rounded-xl border border-border overflow-hidden">
      <div className="overflow-x-auto">
        <table className="w-full">
          <thead className="bg-slate-50 border-b border-border">
            <tr>
              <th className={thCls}>Data</th>
              <th className={thCls}>Número</th>
              <th className={thCls}>Instância</th>
              <th className={thCls}>Capa</th>
              <th className={thCls}>Anexos</th>
              <th className={thCls}>Movimentações</th>
              <th className={thCls}>Status</th>
              <th className={thCls}>Ações</th>
            </tr>
          </thead>
          <tbody className="divide-y divide-border">
            {distribuicoes.length > 0 ? (
              distribuicoes.map((distribuicao) => (
                <tr key={distribuicao.id} className="hover:bg-slate-50 transition-colors">
                  <td className={tdCls}>{formatarData(distribuicao.data_inclusao)}</td>
                  <td className={tdCls}>{distribuicao.numero_processo || "-"}</td>
                  <td className={tdCls}>{distribuicao.instancia || "-"}</td>
                  <td className={`${tdCls} text-center`}>{renderizarStatusBooleano(distribuicao.dados_capa)}</td>
                  <td className={`${tdCls} text-center`}>{renderizarStatusBooleano(distribuicao.anexos)}</td>
                  <td className={`${tdCls} text-center`}>{renderizarStatusBooleano(distribuicao.movimentacoes)}</td>
                  <td className={tdCls}>{renderizarStatus(distribuicao.status)}</td>
                  <td className={tdCls}>
                    {distribuicao.id_processo && import.meta.env.REACT_APP_PROJURIS_ADV_URL && (
                      <a
                        href={`${import.meta.env.REACT_APP_PROJURIS_ADV_URL}/casos/processo/visao-completa/${distribuicao.id_processo}`}
                        target="_blank"
                        rel="noopener noreferrer"
                        className="inline-flex items-center gap-1 text-blue-600 hover:text-blue-800 text-xs underline"
                        title="Visualizar processo no ADV"
                      >
                        Visualizar
                        <ExternalLink className="w-3 h-3" />
                      </a>
                    )}
                  </td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="8" className="px-4 py-8 text-center text-sm text-muted-foreground">
                  Nenhuma distribuição encontrada
                </td>
              </tr>
            )}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default DistribuicoesTable;
